import IconButton from './IconButton.component';

export default IconButton;
